import React, { useEffect, useState } from "react"
import { IErrorModel } from "../../../../types/error/IErrorModel"
import { CommonInput } from "../../../common/element/fields/CommonInput"
import { CommonFileInput } from "../../../common/element/fields/CommonFileInput"
import { IB64File } from "../../../../types/IB64File"
import * as TrinityAPI from "../../../../requests/TrinityAPI"
import { IBrockmanBankDto } from "../../../../types/brockman/IBrockmanBankDto"
import { download, getFieldError, getFormattedDate, round2Digits } from "../../../common/CommonHelper"
import { ModalPopUp } from "../../../common/element/ModalPopUp"
import { IModalMessage } from "../../../../types/error/IModalMessage"
import { CommonFileList } from "../../../common/element/fields/CommonFileList"
import { IMG } from "../../../common/CONST"
import { IClientContractorContract } from "../../../../types/contractor/IClientContractorContract"
import { IClientContractorAgreement } from "../../../../types/contractor/IClientContractorAgreement"
import { ModalConfirm } from "@/components/common/element/ModalConfirm"
import { ICurrencyReplenishmentDto } from "@/types/replenishment/ICurrencyReplenishmentDto"

export const DocsTab: React.FC<{
  replenishment: ICurrencyReplenishmentDto
  setReplenishment: (r: ICurrencyReplenishmentDto) => void
  errorModel: IErrorModel | undefined
  sending: boolean
  submit: () => void
}> = ({ replenishment, setReplenishment, errorModel, sending, submit }) => {
  const [modalConfirm, setModalConfirm] = useState<IModalMessage>()
  const [message, setMessage] = useState<IModalMessage | null>(null)

  const handleContractChange = (file: IB64File) => {
    setReplenishment({ ...replenishment, contract: file })
  }

  const handleSubmitButton = () => {
    doSubmit()
  }

  const doSubmit = () => {
    if (!replenishment.contract && !replenishment.contractPath && !replenishment.contractId) {
      setMessage({ title: "Ошибка!", text: "Загрузите файл контракта" })
      return
    }
    if (!replenishment.contractNumber || replenishment.contractNumber.trim() === "") {
      setMessage({ title: "Ошибка!", text: "Введите номер контракта" })
      return
    }
    if (replenishment.contractDate && new Date(replenishment.contractDate) > new Date()) {
      setMessage({ title: "Ошибка!", text: "Дата контракта не может быть в будущем" })
      return
    }

    submit()
  }

  const isEditable = () => {
    return replenishment.status === "NEW"
  }

  if (!replenishment) {
    return null
  }

  if (replenishment.status === "SLIP_SENT") {
    return (
      <div className="container">
        <div className="container-pop-up">
          <ul className="form-left">
            <li className="form-block-popup">
              <h4 className="heading-chapter">Документы отправлены!</h4>
              <p className="message-course-yes">
                Ваши документы успешно отправлены и находятся на проверке у менеджера. Это может занять некоторое время.
                В случае успешной проверки вы сможете продолжить оформление. В противном случае будет необходимо внести
                исправления в соответствии с комментариями менеджера
              </p>
            </li>
          </ul>
        </div>
      </div>
    )
  } else {
    return (
      <>
        <ModalConfirm message={modalConfirm} setMessage={setModalConfirm} />
        <ModalPopUp message={message} close={() => setMessage(null)} />
        <div className="container" style={!isEditable() ? { pointerEvents: "none", opacity: 0.7 } : {}}>
          <div className="container-pop-up">
            <ul className="form-left">
              {replenishment.contractId ? (
                <></>
              ) : (
                <li className="form-block-popup">
                  <h4 className="heading-chapter">Контракт на валютное пополнение</h4>
                  {replenishment.contractComment ? (
                    <p className="message-course-no">{replenishment.contractComment}</p>
                  ) : (
                    <></>
                  )}
                  <div className="flex-row-10 flex-wrap-mobile">
                    <CommonInput
                      typeName={"date"}
                      label={"Дата"}
                      placeholder={""}
                      name={"contractDate"}
                      value={replenishment.contractDate}
                      errorModel={errorModel}
                      _callback={e =>
                        setReplenishment({
                          ...replenishment,
                          contractDate: e
                        })
                      }
                    />
                    <CommonInput
                      typeName={"text"}
                      label={"Номер"}
                      placeholder={"Введите номер"}
                      name={"contractNumber"}
                      value={replenishment.contractNumber}
                      errorModel={errorModel}
                      _callback={e =>
                        setReplenishment({
                          ...replenishment,
                          contractNumber: e
                        })
                      }
                    />
                    <CommonFileInput
                      label={"Контракт (файл)"}
                      placeholder={replenishment.contract?.b64 || replenishment.contractPath ? "Заменить" : "Загрузить"}
                      name={"contract"}
                      errorModel={errorModel}
                      _callback={handleContractChange}
                      clazzName="fieldset-fit"
                    />
                  </div>
                  <CommonFileList file={replenishment.contract} />
                </li>
              )}
            </ul>
          </div>
          {!isEditable() ? (
            <></>
          ) : (
            <div className="flex-row-10">
              <button className="btn" onClick={handleSubmitButton}>
                {sending ? "Подождите..." : "Далее"}
              </button>
            </div>
          )}
        </div>
      </>
    )
  }
}
